import { render } from "./ProjectActivities.vue?vue&type=template&id=f59ef8c2&scoped=true&ts=true"
import script from "./ProjectActivities.ts?vue&type=script&lang=ts"
export * from "./ProjectActivities.ts?vue&type=script&lang=ts"

import "./ProjectActivities.vue?vue&type=style&index=0&id=f59ef8c2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59ef8c2"]])

export default __exports__